import React from 'react';
import { Link } from 'react-router-dom';


import Icon from '../../components/AppIcon';
import RegistrationForm from './components/RegistrationForm';
import TrialModeNotice from './components/TrialModeNotice';
import SignInPrompt from './components/SignInPrompt';
import SecurityFeatures from './components/SecurityFeatures';


const Register = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="w-full border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-4">
          <Link to="/login" className="inline-flex items-center gap-3 no-underline">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-gradient-to-br from-primary to-secondary">
              <Icon name="public/assets/images/B42A68D7-7405-4964-872F-D36C4B1CBA1C-1768359280145.jpg" size={40} color="#FFFFFF" />
            </div>
            <span className="text-xl font-semibold text-foreground">GalleyPlan</span>
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 md:px-6 lg:px-8 py-8 md:py-12">
        <div className="w-full max-w-2xl space-y-8">
          <div className="text-center mb-8 md:mb-10 lg:mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-2xl mb-4 md:mb-5 lg:mb-6" style={{ background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%)' }}>
              <img src="/assets/images/B42A68D7-7405-4964-872F-D36C4B1CBA1C-1768359280145.jpg" alt="GalleyPlan Logo" className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-cover rounded-2xl" />
            </div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2 md:mb-3">
              Create Your Account
            </h1>
            <p className="text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
              Start planning meals and managing inventory for your coastal cruising adventures
            </p>
          </div>

          <div className="bg-card border border-border rounded-lg p-6 md:p-8 lg:p-10 space-y-8">
            <RegistrationForm />
            
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-border"></div>
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-card px-3 text-muted-foreground font-medium">
                  Account Information
                </span>
              </div>
            </div>

            <TrialModeNotice />
            
            <SignInPrompt />
          </div>

          <SecurityFeatures />

          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              By creating an account, you agree to our Terms of Service and Privacy Policy
            </p>
          </div>
        </div>
      </main>
      <footer className="w-full border-t border-border bg-card py-6">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} GalleyPlan. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Help Center
              </Link>
              <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Register;